<template>
    <div class="d-flex flex-column your-res-list">
      <div class="mt-5">
        <div class="px-5 mb-5">
          <SearchBar
            @onSearch="onFilter"
            type="button"
            :filterBtn="false"
            :valueSearch="filterText"
            class="res-add-btn"
            :levelCounter="{
              Apprentice: props.levelCounter.Apprentice,
              Professional: props.levelCounter.Professional,
              Coach: props.levelCounter.Coach,
              Master: props.levelCounter.Master,
              Novice: props.levelCounter.Novice,
            }"
            :ghostText="'Search Responsibilities'"
            @filterTypes="updateSelectedLevels"
            :readinessSection="true"
            :removeCounterLevelFilter="removeCounterLevelFilter"
            :showNovice="true"
          ></SearchBar>
        </div>
        <DataTable
          v-if="filteredResponsibility?.length > 0"
          :pagination="paginationModel"
          :headers="headers"
          :data="filteredResponsibility"
          @onRequest="requestData"
          class="your-res-table"
        >
          <template #no-data> </template>
          <template #responsibilityAssign="{ row }">
            <div class="pt-2 pb-2">
              <ResponsibilityAssignmentDropDown
                :responsibilityCode="
                  row.responsibilityAssign.data.responsibilityCode
                "
                :responsibilityName="
                  row.responsibilityAssign.data.responsibilityName
                "
                :roleCode="row.responsibilityAssign.data.roleCode"
                :roleName="row.responsibilityAssign.data.roleName"
                :positionCode="row.responsibilityAssign.data.positionCode"
                :positionName="row.responsibilityAssign.data.positionName"
                :responsibilityImportance="
                  row.responsibilityAssign.data.responsibilityImportance
                "
                :roleImportance="row.responsibilityAssign.data.roleImportance"
                :positionImportance="
                  row.responsibilityAssign.data.positionImportance
                "
                :positionCommitment="
                  row.responsibilityAssign.data.positionCommitment
                "
              />
            </div>
          </template>
          <template #badge="{ row }">
            <ReadinessBadge
              v-if="row.responsibilityAssign.data.badgeLevel"
              :level="row.responsibilityAssign.data.badgeLevel"
              :dot="row.responsibilityAssign.data.badgeDot"
              view="Null"
            />
          </template>
          <template #inspectionStatus="{ row }">
            <InspectionIssueBadge
              :currentBadgeLevel="
                row.responsibilityAssign.data.badgeLevel
                  ? row.responsibilityAssign.data.badgeLevel.toLowerCase()
                  : 'novice'
              "
              :checkpoints="
                row.responsibilityAssign.data.checkpoints
                  ? row.responsibilityAssign.data.checkpoints
                  : []
              "
              :currentBadgeStatus="
                row.responsibilityAssign.data.currentBadgeStatus
                  ? getBadgeStatusForInspection(row.responsibilityAssign.data.currentBadgeStatus)
                  : 'good_standing'
              "
              :useCountsVariant="!!row.responsibilityAssign.data.checkpointCounts"
              :checkpointCounts="
                row.responsibilityAssign.data.checkpointCounts || {}
              "
            />
          </template>
          <template #available="{ row }">
            <div
              v-if="row.responsibilityAssign.data.availableInspectors.length > 0"
            >
              <PeopleAvatarsButton
                :avatars="row.responsibilityAssign.data.availableInspectors"
                :isShowTooltip="true"
                :size="'medium'"
                @onAvatarClick="onAvatarClick(row)"
              />
            </div>
          </template>
          <template #actions="{ row }">
            <StandardButton
              type="magenta"
              variant="primary"
              size="small"
              label="Prepare"
              @click="onPrepareClick(row)"
            />
            
          </template>
        </DataTable>
        <NoRecordFound
          v-else-if="!props.loading"
          title=""
          message="Assigned Responsibilities"
          btnTitle=""
          :showSpecificMessage="
            shouldShowClearButton
              ? 'No results found'
              : 'You currently have no Assigned Responsibilities'
          "
          :description="
            shouldShowClearButton
              ? `Please ${noResultsMessage.toLowerCase()} to see your responsibilities.`
              : 'Reach out to your manager to ask for a Position Assignment including Roles and Responsibilities'
          "
          :showActiveCounter="false"
          :shouldShowAddAction="false"
          :addOrAskIQButton="{ enabled: false }"
          :showClearAction="shouldShowClearButton"
          :clearLabel="clearButtonLabel"
          noBorder
          class="your-res-not-found"
          @onClear="handleClearFilters"
        />
      </div>
    </div>
</template>
<script setup>
import { ref, computed, watch, onMounted } from "vue";
import DataTable from "@components/DataTable/DataTable.vue";
import SearchBar from "@components/SearchBar/SearchBar.vue";
import ReadinessBadge from "@components/ReadinessBadge/ReadinessBadge.vue";
import InspectionIssueBadge from "@components/InspectionIssueBadge/InspectionIssueBadge.vue";
import PeopleAvatarsButton from "@components/PeopleAvatarsButton/PeopleAvatarsButton.vue";
import StandardButton from "@components/StandardButton/StandardButton.vue";
import ResponsibilityAssignmentDropDown from "@components/ResponsibilityAssignmentDropDown/ResponsibilityAssignmentDropDown.vue";
import NoRecordFound from "@components/NoRecordFound/NoRecordFound.vue";
const props = defineProps({
  headers: {
    type: Array,
    default: () => [],
  },
  data: {
    type: Array,
    default: () => [],
  },
  pagination: {
    type: Object,
    default: () => ({
      page: 1,
      total: 0,
      perPage: 10,
    }),
  },
  levelCounter: {
    type: Object,
    default: () => ({
      Apprentice: 0,
      Professional: 0,
      Coach: 0,
      Master: 0,
      Novice: 0,
    }),
  },
  loading: {
    type: Boolean,
    default: false,
  },
});

const filterText = ref("");
const paginationModel = ref({ ...props.pagination });
const resData = ref([...props.data]);
const removeCounterLevelFilter = ref(false);
const selectedLevels = ref([]);
const isFiltering = ref(false);

const filteredResponsibility = computed(() => {
  let resultArray = [];
  resultArray = resData.value.map((el) => {
    const newEl = {
      responsibilityAssign: {
        slot: "responsibilityAssign",
        data: el,
      },
      badge: {
        slot: "badge",
      },
      inspectionStatus: {
        slot: "inspectionStatus",
      },
      available: {
        slot: "available",
      },
      actions: {
        slot: "actions",
      },
    };
    return newEl;
  });
  // Note: Search filtering is now handled server-side via API
  // The filterText is sent to backend via the onSearch emit
  return resultArray.sort((a, b) => {
    const dataA = a.responsibilityAssign.data;
    const dataB = b.responsibilityAssign.data;

    // First sort by rank descending
    const rankA = dataA.rank || 0;
    const rankB = dataB.rank || 0;
    if (rankB !== rankA) {
      return rankB - rankA;
    }

    // Then sort by Readiness level with Novice on top
    const getReadinessOrder = (badgeLevel) => {
      // Novice (null/undefined) should be first (order 0)
      if (!badgeLevel) return 0;
      const level = badgeLevel.toLowerCase();
      // Order: Novice (0), Apprentice (1), Professional (2), Coach (3), Master (4)
      const orderMap = {
        novice: 0,
        apprentice: 1,
        professional: 2,
        coach: 3,
        master: 4,
      };
      return orderMap[level] ?? 5; // Unknown levels go last
    };

    const readinessOrderA = getReadinessOrder(dataA.badgeLevel);
    const readinessOrderB = getReadinessOrder(dataB.badgeLevel);
    return readinessOrderA - readinessOrderB;
  });
});

const filteredEmptyResponsibility = computed(() => {
  return resData.value;
});

const shouldShowTable = computed(() => {
  // If loading or filtering, always show table to prevent wrong message from appearing
  if (props.loading || isFiltering.value) {
    return true;
  }

  // If there are any filters or search applied, show the table regardless of items
  // This ensures we show the "no results" message instead of "no assigned responsibilities"
  const hasFiltersApplied =
    selectedLevels.value && selectedLevels.value.length > 0;
  const hasSearchApplied =
    filterText.value && filterText.value.trim().length > 0;

  if (hasFiltersApplied || hasSearchApplied) {
    return true;
  }

  // Also show table if pagination indicates there might be data (even if current page is empty)
  if (paginationModel.value.total > 0) {
    return true;
  }

  // Otherwise, show table only if there's data
  return filteredEmptyResponsibility.value?.length > 0;
});

// Computed property to determine if clear button should be shown
const shouldShowClearButton = computed(() => {
  const hasFiltersApplied =
    selectedLevels.value && selectedLevels.value.length > 0;
  const hasSearchApplied =
    filterText.value && filterText.value.trim().length > 0;
  return hasFiltersApplied || hasSearchApplied;
});

// Computed property to determine clear button label (always "Clear")
const clearButtonLabel = computed(() => {
  return "Clear";
});

// Computed property to determine the message when filters/search are applied
const noResultsMessage = computed(() => {
  const hasFiltersApplied =
    selectedLevels.value && selectedLevels.value.length > 0;
  const hasSearchApplied =
    filterText.value && filterText.value.trim().length > 0;

  if (hasFiltersApplied && hasSearchApplied) {
    return "Clear search/filter";
  } else if (hasSearchApplied) {
    return "Clear search";
  } else if (hasFiltersApplied) {
    return "Clear filter";
  }
  return "";
});

const emit = defineEmits([
  "onPaginationRequest",
  "onSearch",
  "onAvatarClick",
  "onPrepareClick",
  "onLevelsChange",
  "onClearFilters",
]);

const onFilter = (data) => {
  // Set filtering state immediately to show table section and prevent wrong message
  isFiltering.value = true;
  filterText.value = data;
  if (data) {
    paginationModel.value.page = 1;
  }
  // Emit search to parent to trigger backend search
  emit("onSearch", data);
};

const onAvatarClick = (row) => {
  // Emit avatar click to parent with row data
  emit("onAvatarClick", row.responsibilityAssign.data);
};

const onPrepareClick = (row) => {
  // Emit prepare click to parent with row data
  emit("onPrepareClick", row.responsibilityAssign.data);
};

const requestData = async (data) => {
  if (data && data.page) {
    paginationModel.value.page = data.page;
    // Emit to parent to fetch new data from API
    emit("onPaginationRequest", data);
  }
};
const getBadgeStatusForInspection = (status) => {
  // Map the badge status to what InspectionIssueBadge component expects
  if (status === "given") {
    return "forced";
  } else if (status === "good_standing") {
    return "good_standing";
  } else if (status === "awarded") {
    return "good_standing"; // Map awarded to good_standing
  } else if (status === "obsolete") {
    return "obsolete";
  } else {
    return "null"; // default fallback
  }
};

watch(
  () => props.data,
  (newVal) => {
    resData.value = newVal;
    // Clear filtering state when data is updated (API call completed)
    // Only clear if we're not currently loading (to prevent flicker)
    if (!props.loading) {
      isFiltering.value = false;
    }
  }
);

watch(
  () => props.pagination,
  (newVal) => {
    paginationModel.value = { ...newVal };
    // Clear filtering state when pagination is updated (API call completed)
    if (!props.loading) {
      isFiltering.value = false;
    }
  },
  { deep: true }
);

watch(selectedLevels, (newLevels) => {
  paginationModel.value.page = 1;
  // If levels are cleared, clear filtering state only if search is also empty
  if (!newLevels || newLevels.length === 0) {
    if (!filterText.value || filterText.value.trim().length === 0) {
      isFiltering.value = false;
    }
  }
});

const updateSelectedLevels = (levels) => {
  // Set filtering state immediately to show table section and prevent wrong message
  if (levels && levels.length > 0) {
    isFiltering.value = true;
  }
  if (removeCounterLevelFilter.value) {
    removeCounterLevelFilter.value = false;
  }
  selectedLevels.value = levels;
  // Emit selected levels to parent component
  emit("onLevelsChange", levels);
};

// Handle clear filters button click
const handleClearFilters = () => {
  const hasFiltersApplied =
    selectedLevels.value && selectedLevels.value.length > 0;
  const hasSearchApplied =
    filterText.value && filterText.value.trim().length > 0;

  // Clear search if it exists
  if (hasSearchApplied) {
    filterText.value = "";
    emit("onSearch", "");
  }

  // Clear filters if they exist
  if (hasFiltersApplied) {
    selectedLevels.value = [];
    removeCounterLevelFilter.value = true;
    emit("onLevelsChange", []);
  }

  // Reset filtering state
  isFiltering.value = false;

  // Emit clear event to parent
  emit("onClearFilters", {
    clearedSearch: hasSearchApplied,
    clearedFilters: hasFiltersApplied,
  });
};

onMounted(() => {
  // Use pagination from props for server-side pagination
  if (props.pagination && props.pagination.total) {
    paginationModel.value = { ...props.pagination };
  }
});
</script>
<style>
.your-res-list {
  border: 1px solid #eaecf0;
  margin-bottom: 60px;
}
.res-add-btn .storybook-button--btn-normal-hover-icon {
  font-size: 14px !important;
}
.your-res-not-found .top-heading {
  visibility: hidden !important;
}
.pre-btn {
  width: 95px !important;
}
.order-text {
  font-family: Inter;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: #101828;
  background-color: #f9fafb;
  border: 1px solid #eaecf0;
  padding: 5px 10px;
}
.your-res-table
  .theme--light.v-data-table
  > .v-data-table__wrapper
  > table
  > tbody
  > tr:hover {
  background-color: transparent !important;
}
.your-res-table
  .theme--light.v-data-table
  > .v-data-table__wrapper
  > table
  > tbody
  > tr
  > td {
  max-width: 0;
}
.your-res-table
  .theme--light.v-data-table
  > .v-data-table__wrapper
  > table
  > tbody
  > tr
  > td:last-child {
  max-width: none;
  width: auto;
}
.your-res-table .pt-2.pb-2 {
  width: 100%;
  max-width: 100%;
}
.your-res-table .rad__trigger-btn {
  width: auto !important;
}
</style>
